export const theme = {
  colors: {
    black: "#333",
    white: "#fff",
    subwhite: "#f9f9f9",
    offwhite: "#f5f5f6",
    grey: "#888",
    lightgrey: "#f5f5f5",
    primary: "#7a2d03",
    secondary: "orange",
  },
}
